

import React, { useEffect, useState } from "react";
import Card from "components/card";
import Chart from "react-apexcharts";
import axios from "axios";
import { API_BASE_URL } from "../../../../config";

const AdsExpense = () => {
  const [chartSeries, setChartSeries] = useState([
    { name: "Fresh Call", data: [] },
    { name: "Re-call", data: [] },
  ]);
  const [categories, setCategories] = useState([]);
  const [counts, setCounts] = useState({ daily: null, weekly: [], monthly: [] });
  const [activeTab, setActiveTab] = useState("daily");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${API_BASE_URL}/api/customer/total-call-stats?type=all`,
          {
            headers: {
              token,
            },
          }
        );
        if (res.data.success) {
          setCounts(res.data.result);
          // Default to daily view
          updateChart(res.data.result.daily, "daily");
        }
      } catch (error) {
        // console.error("Error fetching chart data:", error);
      }
    };
    fetchData();
  }, []);

  const updateChart = (data, type) => {
    let freshData = [];
    let recallData = [];
    let categoryArr = [];

    if (type === "daily" && data) {
      // For daily, data is a single object
      freshData = [data.freshCall];
      recallData = [data.reCall];
      categoryArr = [data.date.slice(5)]; // "YYYY-MM-DD" -> "MM-DD"
    }

    if (type === "weekly" && Array.isArray(data)) {
      freshData = data.map((d) => d.freshCall);
      recallData = data.map((d) => d.reCall);
      categoryArr = data.map((d) => d.week); // "Week 1", "Week 2", etc.
    }

    if (type === "monthly" && Array.isArray(data)) {
      freshData = data.map((d) => d.freshCall);
      recallData = data.map((d) => d.reCall);
      categoryArr = data.map((d) => d.month.slice(0, 3)); // "January" -> "Jan"
    }

    setChartSeries([
      { name: "Fresh Call", data: freshData },
      { name: "Re-call", data: recallData },
    ]);
    setCategories(categoryArr);
  };

  const handleTabClick = (type) => {
    setActiveTab(type);
    updateChart(counts[type], type);
  };

  // Calculate totals for display
  const getTotals = () => {
    if (activeTab === "daily" && counts.daily) {
      return {
        fresh: counts.daily.freshCall,
        recall: counts.daily.reCall
      };
    }

    if ((activeTab === "weekly" || activeTab === "monthly") && Array.isArray(counts[activeTab])) {
      return {
        fresh: counts[activeTab].reduce((sum, item) => sum + item.freshCall, 0),
        recall: counts[activeTab].reduce((sum, item) => sum + item.reCall, 0)
      };
    }

    return { fresh: 0, recall: 0 };
  };

  const totals = getTotals();

  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("dark"));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const chartOptions = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: { bar: { columnWidth: "45%", borderRadius: 6 } },
    colors: ["#fbbf24", "#1e293b"],
    dataLabels: { enabled: false },
    legend: {
      show: true,
      labels: { colors: isDarkMode ? "#fff" : "#000", useSeriesColors: false }
    },
    xaxis: { categories, labels: { style: { colors: isDarkMode ? "#fff" : "#64748b", fontSize: "12px" } } },
    yaxis: { labels: { style: { colors: isDarkMode ? "#fff" : "#64748b" } } },
    tooltip: { theme: isDarkMode ? "dark" : "light" },
    grid: { show: false },
  };

  return (
    <Card extra="flex flex-col bg-white w-full rounded-3xl py-6 px-2">
      <div className="flex items-center justify-between px-6">
        <div className="flex flex-col items-start">
          <h2 className="text-lg font-bold text-navy-700 dark:text-white">
            Call Statistics
          </h2>
          <p className="text-sm text-gray-500">
            Fresh: {totals.fresh} | Re-call: {totals.recall}
          </p>
        </div>
      </div>

      <div className="mt-3 flex gap-2 px-6">
        {/* Tabs */}
        <button
          onClick={() => handleTabClick("daily")}
          className={`flex-1 rounded-xl py-2 font-medium ${activeTab === "daily"
            ? "bg-yellow-400 text-navy-700 dark:text-black"
            : "bg-gray-200 text-gray-600 dark:text-black"
            }`}
        >
          Daily
        </button>
        <button
          onClick={() => handleTabClick("weekly")}
          className={`flex-1 rounded-xl py-2 font-medium ${activeTab === "weekly"
            ? "bg-yellow-400 text-navy-700 dark:text-black"
            : "bg-gray-200 text-gray-600 dark:text-black"
            }`}
        >
          Weekly
        </button>
        <button
          onClick={() => handleTabClick("monthly")}
          className={`flex-1 rounded-xl py-2 font-medium ${activeTab === "monthly"
            ? "bg-yellow-400 text-navy-700 "
            : "bg-gray-200 text-gray-600 "
            }`}
        >
          Monthly
        </button>
      </div>

      <div className="mt-6 px-2">
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="bar"
          height={220}
        />
      </div>
    </Card>
  );
};

export default AdsExpense;

